/**
 * CSS imports
 */

// Tailwind
// import "@cmu-sei/sei-design-system/open-sans/index.css";
import "./css/main.css";
import "@cmu-sei/sei-design-system/dist/style.css";

// Fonts
import './css/ewp/fonts/source-serif.css';
import './css/ewp/fonts/open-sans.css';

// Font Awesome — fontawesome.min.css has no url() refs so it's safe to bundle;
// the 4 style-specific FA CSS files (regular/solid/brands/light) and the
// font-display override (which has url(...woff2) refs) are loaded non-blocking
// via <link media="print"> in head.html instead, to keep them off the
// render-blocking critical path (see vite.config.js viteStaticCopy targets).
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css';

// Overrides
import "./css/ewp/sei-tailwind-entry.css";

/* Tailwind for Tailwind CSS support */
import "./css/ewp/base/typography.css"
import "./css/ewp/base/spacing.css"
import "./css/ewp/base/observers.css"
import "./css/ewp/base/scrollbar.css"

/**
 * Typescript/JavaScript imports
 */

// Vite polyfill for modulepreload
// This is necessary for older browsers that do not support the modulepreload feature.
// It allows the application to load modules in a way that is compatible with those browsers.
// This is typically automatically included by Vite, but we are explicitly importing it here
// because we have a custom entry point for our application.
import "vite/modulepreload-polyfill";

// Legacy scripts
import "./ts/legacy/index";

// Vue application initialization
import "./vue/main";

/**
 * Blocks
 */

// PrismJS for code blocks: a separate chunk, fetched only on pages that have one
if (document.querySelector('code[data-codeblock="prism"]')) import("./ts/blocks/code-block/code-block");

// Browse by block toggle functionality
import "./ts/blocks/browse-by-toggle";

// Video hero responsive poster handling
import "./ts/blocks/video-hero";

// Responsive hero background image handling (CSS background heroes)
import "./ts/blocks/hero-responsive";

// YouTube embed facade — defers loading the real player until clicked
import "./ts/blocks/youtube-facade";

// Mount all new UI patterns/blocks
import "./ts/blocks/blocks";
